export enum AddressType {
  Pickup,
  Delivery,
  Exporter,
}
